const TicketsRedemption = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_980_98608)">
      <path
        d="M6.87549 8.125H13.1255"
        stroke="#444444"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.87549 11.875H13.1255"
        stroke="#444444"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8755 10C16.8755 8.48875 17.9492 7.2275 19.3755 6.9375V4.375C19.3755 3.685 18.8155 3.125 18.1255 3.125H1.87549C1.18549 3.125 0.625488 3.685 0.625488 4.375V6.9375C2.05174 7.2275 3.12549 8.4875 3.12549 10C3.12549 11.5112 2.05174 12.7725 0.625488 13.0625V15.625C0.625488 16.315 1.18549 16.875 1.87549 16.875H18.1255C18.8155 16.875 19.3755 16.315 19.3755 15.625V13.0625C17.9492 12.7725 16.8755 11.5112 16.8755 10Z"
        stroke="#444444"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_980_98608">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.000488281)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default TicketsRedemption;
